// CÓDIGO COMPLETO E REDESENHADO para: src/pages/LaboratorioDashboard.js

import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase/config';
import { collection, query, where, onSnapshot, doc, updateDoc, getDoc, getDocs } from 'firebase/firestore';
import { registrarAuditoria } from '../services/auditoriaService';
import Navbar from '../components/Navbar';
// ... seus imports de CSS

// --- Modal de Análise Individual ---
function AnalysisModal({ amostra, visita, onClose, onSave, user }) {
    const initialState = {
        status: 'PENDENTE',
        aegypti: { larvas: 0, pupas: 0, adultos: 0 },
        albopictus: { larvas: 0, pupas: 0, adultos: 0 },
        outros: { larvas: 0, pupas: 0, adultos: 0 },
        observacoes: ''
    };

    // 2. Mescla os dados que já existem na amostra (amostra.analise) com a estrutura padrão.
    //    Isso garante que os campos como 'aegypti' sempre existam.
    const [analiseData, setAnaliseData] = useState({
        ...initialState,
        ...(amostra.analise || {}), // Pega os dados existentes da análise, se houver
        // Garante que os objetos aninhados também existam
        aegypti: { ...initialState.aegypti, ...(amostra.analise?.aegypti || {}) },
        albopictus: { ...initialState.albopictus, ...(amostra.analise?.albopictus || {}) },
        outros: { ...initialState.outros, ...(amostra.analise?.outros || {}) },
    });

    const handleChange = (e, especie, estagio) => {
        const { value } = e.target;
        setAnaliseData(prev => ({
            ...prev,
            [especie]: { ...prev[especie], [estagio]: Number(value) || 0 }
        }));
    };

    const handleSave = async () => {
        const dadosFinais = {
            ...analiseData,
            status: 'CONCLUIDO', // Padrão MAIÚSCULO
            dataAnalise: new Date(),
            laboratorista: { uid: user.uid, email: user.email }
        };
        await onSave(dadosFinais);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h4>Análise do Tubito: {amostra.notaInicial}</h4>
                <div className="summary-box-lab">
                    <strong>Local:</strong> {visita.localidade}, {visita.logradouro}, Nº {visita.numeroImovel} | <strong>Depósito:</strong> {amostra.depositoColeta}
                </div>
                <fieldset><legend>Aedes aegypti</legend>
                    <div className="form-grid deposits">
                        <div className="input-group">
                            <label>Larvas</label>
                            <input type="number" min="0" value={analiseData.aegypti?.larvas || 0} onChange={e => handleChange(e, 'aegypti', 'larvas')} />
                        </div>
                        <div className="input-group">
                            <label>Pupas</label>
                            <input type="number" min="0" value={analiseData.aegypti?.pupas || 0} onChange={e => handleChange(e, 'aegypti', 'pupas')} />
                        </div>
                        {/* ▼▼▼ CAMPO ADICIONADO ▼▼▼ */}
                        <div className="input-group">
                            <label>Exúvia de pupa</label>
                            <input type="number" min="0" value={analiseData.aegypti?.exuvia || 0} onChange={e => handleChange(e, 'aegypti', 'exuvia')} />
                        </div>
                        <div className="input-group">
                            <label>Adultos</label>
                            <input type="number" min="0" value={analiseData.aegypti?.adultos || 0} onChange={e => handleChange(e, 'aegypti', 'adultos')} />
                        </div>
                    </div>
                </fieldset>

                <fieldset><legend>Aedes albopictus</legend>
                    <div className="form-grid deposits">
                        <div className="input-group">
                            <label>Larvas</label>
                            <input type="number" min="0" value={analiseData.albopictus?.larvas || 0} onChange={e => handleChange(e, 'albopictus', 'larvas')} />
                        </div>
                        <div className="input-group">
                            <label>Pupas</label>
                            <input type="number" min="0" value={analiseData.albopictus?.pupas || 0} onChange={e => handleChange(e, 'albopictus', 'pupas')} />
                        </div>
                        <div className="input-group">
                            <label>Exúvia de pupa</label>
                            <input type="number" min="0" value={analiseData.albopictus?.exuvia || 0} onChange={e => handleChange(e, 'albopictus', 'exuvia')} />
                        </div>
                        <div className="input-group">
                            <label>Adultos</label>
                            <input type="number" min="0" value={analiseData.albopictus?.adultos || 0} onChange={e => handleChange(e, 'albopictus', 'adultos')} />
                        </div>
                    </div>
                </fieldset>
                <div className="modal-actions">
                    <button type="button" onClick={onClose}>Cancelar</button>
                    <button type="button" onClick={handleSave}>Salvar Análise</button>
                </div>
            </div>
        </div>
    );
}

// --- Painel Principal do Laboratório ---
function LaboratorioDashboard({ user }) {
    // Estado de navegação das abas
    const [activeTab, setActiveTab] = useState('pendentes'); // 'pendentes' | 'busca'

    // Estados para aba PENDENTES
    const [tubitosPendentes, setTubitosPendentes] = useState([]);
    const [loadingPendentes, setLoadingPendentes] = useState(true);

    // Estados para aba BUSCA
    const [searchFilters, setSearchFilters] = useState({
        startDate: '',
        endDate: '',
        agente: ''
    });
    const [searchResults, setSearchResults] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [searchPerformed, setSearchPerformed] = useState(false);

    // Estados comuns
    const [selectedTubito, setSelectedTubito] = useState(null);
    const [agentsMap, setAgentsMap] = useState({});

    // Estado para forçar recarregamento
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        const fetchAgents = async () => {
            try {
                const q = query(collection(firestore, "usuarios"), where("perfil", "==", "agente"));
                const querySnapshot = await getDocs(q);
                const map = {};
                querySnapshot.docs.forEach(doc => {
                    const data = doc.data();
                    map[doc.id] = data.nome || data.email;
                    // Mapeamento também por email para facilitar busca
                    if (data.email) map[data.email] = data.nome;
                });
                setAgentsMap(map);
            } catch (error) {
                console.error("Erro ao buscar agentes:", error);
            }
        };
        fetchAgents();
    }, []);

    // --- LÓGICA DA ABA PENDENTES ---
    useEffect(() => {
        setLoadingPendentes(true); // Garante o loading visual ao recarregar
        // OTIMIZAÇÃO: Filtra apenas os últimos 30 dias para evitar leitura excessiva
        const trintaDiasAtras = new Date();
        trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 30);

        const q = query(
            collection(firestore, "relatoriosDiarios_FAD1"),
            where("coletaAmostra", "==", true),
            where("dataAtividade", ">=", trintaDiasAtras)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const amostras = [];
            snapshot.docs.forEach(doc => {
                const visita = { id: doc.id, ...doc.data() };
                visita.amostras?.forEach((amostra, index) => {
                    // Verifica se a visita está ATIVA antes de listar (ROBUSTO)
                    const statusVisita = visita.statusRegistro ? visita.statusRegistro.trim().toLowerCase() : 'ativo';
                    if (statusVisita !== 'ativo') return; // Ignora amostras de visitas canceladas

                    // Verifica status de forma insensível a maiúsculas/minúsculas
                    const status = amostra.analise?.status ? amostra.analise.status.toUpperCase() : 'PENDENTE';
                    if (status === 'PENDENTE') {
                        amostras.push({ ...amostra, _visitaId: visita.id, _amostraIndex: index, visita });
                    }
                });
            });
            setTubitosPendentes(amostras);
            setLoadingPendentes(false);
        }, (error) => {
            console.error("Erro ao buscar amostras:", error);
            setLoadingPendentes(false);
        });
        return () => unsubscribe();
    }, [refreshKey]); // Atualiza quando refreshKey mudar

    // --- LÓGICA DA ABA BUSCA ---
    const handleSearch = async () => {
        if (!searchFilters.startDate || !searchFilters.endDate) {
            alert("Selecione a data inicial e final.");
            return;
        }

        const start = new Date(searchFilters.startDate + 'T00:00:00');
        const end = new Date(searchFilters.endDate + 'T23:59:59');

        // Validação de intervalo de 7 dias
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 7) {
            alert("O intervalo máximo de busca é de 7 dias.");
            return;
        }

        setLoadingSearch(true);
        setSearchPerformed(true);
        setSearchResults([]);

        try {
            const q = query(
                collection(firestore, "relatoriosDiarios_FAD1"),
                where("coletaAmostra", "==", true),
                where("dataAtividade", ">=", start),
                where("dataAtividade", "<=", end)
            );

            const snapshot = await getDocs(q);
            const resultados = [];

            snapshot.docs.forEach(doc => {
                const visita = { id: doc.id, ...doc.data() };

                // Filtrar visitas canceladas (ROBUSTO)
                const statusReg = visita.statusRegistro ? visita.statusRegistro.trim().toLowerCase() : 'ativo';
                if (statusReg !== 'ativo') {
                    return; // Pula visitas canceladas
                }

                // Filtro de Agente (Cliente-side)
                if (searchFilters.agente) {
                    const agenteKey = visita.idAgente || visita.emailAgente || '';
                    const nomeAgente = agentsMap[agenteKey] || agentsMap[visita.emailAgente] || agenteKey;
                    if (!nomeAgente.toLowerCase().includes(searchFilters.agente.toLowerCase())) {
                        return; // Pula esta visita
                    }
                }

                visita.amostras?.forEach((amostra, index) => {
                    const status = amostra.analise?.status ? amostra.analise.status.toUpperCase() : 'PENDENTE';
                    // Na busca, queremos ver tudo, ou focar nos CONCLUÍDOS? 
                    // O pedido foi "amostras que ja foram verificadas", então filteramos status != PENDENTE
                    if (status !== 'PENDENTE') {
                        resultados.push({ ...amostra, _visitaId: visita.id, _amostraIndex: index, visita });
                    }
                });
            });

            setSearchResults(resultados);
        } catch (error) {
            console.error("Erro na busca:", error);
            alert("Erro ao buscar amostras.");
        } finally {
            setLoadingSearch(false);
        }
    };

    // Helper para limitar data final (max 7 dias)
    const getMaxDate = (start) => {
        if (!start) return '';
        const d = new Date(start);
        d.setDate(d.getDate() + 6); // 7 dias de intervalo (start + 6)
        return d.toISOString().split('T')[0];
    };

    // --- SALVAR ANÁLISE (Serve para Novo e Edição) ---
    const handleSaveAnalysis = async (dadosAnalise) => {
        const { _visitaId, _amostraIndex } = selectedTubito;
        const visitaRef = doc(firestore, "relatoriosDiarios_FAD1", _visitaId);

        try {
            // 1. Buscar visita atualizada do banco
            const docSnap = await getDoc(visitaRef);
            if (!docSnap.exists()) throw new Error("Visita não encontrada!");
            const visitaAtual = { id: docSnap.id, ...docSnap.data() };

            const amostrasAtualizadas = [...visitaAtual.amostras];
            // CLONE para garantir que temos o dado antigo intacto (pois vamos mutar o array/objeto abaixo)
            const analiseAntiga = amostrasAtualizadas[_amostraIndex]?.analise ? JSON.parse(JSON.stringify(amostrasAtualizadas[_amostraIndex].analise)) : null;

            // 2. Aplicar atualização (Muta o objeto dentro do array)
            if (amostrasAtualizadas[_amostraIndex]) {
                amostrasAtualizadas[_amostraIndex] = {
                    ...amostrasAtualizadas[_amostraIndex],
                    analise: dadosAnalise
                };
            }

            // 3. Recalcular Status Geral da Visita
            // Correção: Case Insensitive check
            const todasAnalisadas = amostrasAtualizadas.every(a => a.analise?.status?.toUpperCase() === 'CONCLUIDO');
            const algumaAnalisada = amostrasAtualizadas.some(a => a.analise?.status?.toUpperCase() === 'CONCLUIDO');

            let novoStatus = 'Aguardando Análise';
            if (todasAnalisadas) novoStatus = 'Análise Concluída';
            else if (algumaAnalisada) novoStatus = 'Análise Parcial';

            const dadosUpdate = {
                amostras: amostrasAtualizadas,
                status: novoStatus
            };

            await updateDoc(visitaRef, dadosUpdate);

            // 4. AUDITORIA:
            const statusAntigo = analiseAntiga?.status?.toUpperCase();
            // Se o status anterior era CONCLUIDO, registramos a auditoria detalhada
            if (statusAntigo === 'CONCLUIDO') {
                const labelAmostra = `Amostra ${selectedTubito.notaInicial || (_amostraIndex + 1)}`;

                // Remove campos administrativos que sempre mudam ou não importam para a diff de "resultado"
                const limparDados = (dados) => {
                    if (!dados) return {};
                    const { laboratorista, dataAnalise, ...resto } = dados;
                    return resto;
                };

                const auditAntigo = { [labelAmostra]: limparDados(analiseAntiga) };
                const auditNovo = { [labelAmostra]: limparDados(dadosAnalise) };

                await registrarAuditoria(_visitaId, auditAntigo, auditNovo, user);
            }

            // 5. Atualizar UI
            if (activeTab === 'busca') {
                // Atualiza a lista de busca localmente para refletir a mudança sem nova query
                setSearchResults(prev => prev.map(item => {
                    if (item._visitaId === _visitaId && item._amostraIndex === _amostraIndex) {
                        return { ...item, analise: dadosAnalise };
                    }
                    return item;
                }));
            }

            setSelectedTubito(null);
            alert('Análise salva com sucesso!');

        } catch (error) {
            console.error("Erro ao salvar:", error);
            alert("Erro ao salvar análise.");
        }
    };

    const handleReload = () => {
        if (activeTab === 'pendentes') {
            // Força nova subscrição no useEffect
            setRefreshKey(prev => prev + 1);
        } else if (activeTab === 'busca' && searchPerformed) {
            // Refaz a busca
            handleSearch();
        } else {
            alert("Realize uma busca primeiro para recarregar.");
        }
    };

    return (
        <div>
            <Navbar user={user} />
            <div className="dashboard-container">
                {/* --- TAB SWITCHER E BOTÃO RECARREGAR --- */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div className="view-switcher" style={{ marginBottom: 0 }}>
                        <button
                            onClick={() => setActiveTab('pendentes')}
                            className={activeTab === 'pendentes' ? 'active' : ''}
                        >
                            Pendente de Análise
                        </button>
                        <button
                            onClick={() => setActiveTab('busca')}
                            className={activeTab === 'busca' ? 'active' : ''}
                        >
                            Buscar Realizadas
                        </button>
                    </div>

                    <button
                        onClick={handleReload}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#6c757d',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: '500'
                        }}
                        title="Recarregar dados"
                    >
                        <span>↻</span> Recarregar Dados
                    </button>
                </div>

                {/* --- CONTEÚDO DA ABA PENDENTES --- */}
                {activeTab === 'pendentes' && (
                    <>
                        <h3>Tubitos Pendentes</h3>
                        {loadingPendentes ? (
                            <p>Carregando amostras pendentes...</p>
                        ) : tubitosPendentes.length === 0 ? (
                            <p>Nenhuma amostra aguardando análise no momento.</p>
                        ) : (
                            <TabelaAmostras
                                lista={tubitosPendentes}
                                agentsMap={agentsMap}
                                onAction={(item) => setSelectedTubito(item)}
                                labelAction="Analisar"
                            />
                        )}
                    </>
                )}

                {/* --- CONTEÚDO DA ABA BUSCA --- */}
                {activeTab === 'busca' && (
                    <>
                        <h3>Buscar Amostras Concluídas</h3>
                        <div className="filters-container">
                            <div className="input-group">
                                <label>Início</label>
                                <input
                                    type="date"
                                    value={searchFilters.startDate}
                                    onChange={e => {
                                        const newStart = e.target.value;
                                        setSearchFilters(prev => {
                                            let newEnd = prev.endDate;
                                            if (newStart) {
                                                // UX: Auto-preenche a data final com o máximo permitido (Start + 6 dias)
                                                // Isso facilita para o usuário não ter que clicar duas vezes
                                                newEnd = getMaxDate(newStart);
                                            }
                                            return { ...prev, startDate: newStart, endDate: newEnd };
                                        });
                                    }}
                                />
                            </div>
                            <div className="input-group">
                                <label>Fim</label>
                                <input
                                    type="date"
                                    value={searchFilters.endDate}
                                    min={searchFilters.startDate}
                                    max={getMaxDate(searchFilters.startDate)}
                                    onChange={e => setSearchFilters(prev => ({ ...prev, endDate: e.target.value }))}
                                />
                            </div>
                            <div className="input-group">
                                <label>Agente (Nome)</label>
                                <input type="text" placeholder="Filtrar por nome..." value={searchFilters.agente} onChange={e => setSearchFilters(prev => ({ ...prev, agente: e.target.value }))} />
                            </div>
                            <button onClick={handleSearch} style={{ alignSelf: 'flex-end', height: '40px' }} disabled={loadingSearch}>
                                {loadingSearch ? 'Buscando...' : 'Buscar'}
                            </button>
                        </div>

                        {searchPerformed && (
                            <>
                                {searchResults.length === 0 ? (
                                    <p style={{ marginTop: '20px' }}>Nenhuma amostra encontrada nesses critérios.</p>
                                ) : (
                                    <>
                                        <p style={{ marginTop: '10px' }}><strong>{searchResults.length}</strong> amostra(s) encontrada(s).</p>
                                        <TabelaAmostras
                                            lista={searchResults}
                                            agentsMap={agentsMap}
                                            onAction={(item) => setSelectedTubito(item)}
                                            labelAction="Editar / Ver"
                                        />
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>

            {selectedTubito && (
                <AnalysisModal
                    amostra={selectedTubito}
                    visita={selectedTubito.visita}
                    onClose={() => setSelectedTubito(null)}
                    onSave={handleSaveAnalysis}
                    user={user}
                />
            )}
        </div>
    );
}

// Sub-componente para evitar duplicação de tabela
function TabelaAmostras({ lista, agentsMap, onAction, labelAction }) {
    return (
        <div className="table-wrapper">
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Data Coleta</th>
                        <th>Agente</th>
                        <th>Localidade</th>
                        <th>Depósito</th>
                        <th>Nota Inicial (ID)</th>
                        <th>Status</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {lista.map((tubito, idx) => (
                        <tr key={`${tubito._visitaId}-${tubito._amostraIndex}-${idx}`}>
                            <td>{tubito.visita.dataAtividade?.toDate().toLocaleDateString('pt-BR')}</td>
                            <td>{agentsMap[tubito.visita.idAgente] || tubito.visita.emailAgente}</td>
                            <td>{tubito.visita.localidade}</td>
                            <td>{tubito.depositoColeta}</td>
                            <td>{tubito.notaInicial}</td>
                            <td>{tubito.analise?.status || 'PENDENTE'}</td>
                            <td>
                                <button className="edit-button" onClick={() => onAction(tubito)}>
                                    {labelAction}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default LaboratorioDashboard;